// extracted by mini-css-extract-plugin
module.exports = {"main":"ingredient-card_main__MXewe","price":"ingredient-card_price__2yNO5","name":"ingredient-card_name__27PBy"};